import IComponent from "components/commons/IComponent";
import "./nodeTree.scoped.css";
import DownloadFromWebAPI from "utils/DownloadFromWebAPI";

class ClassName extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  processTreeObj(input) {
    let tree = input.reduce(
      (p, c, i) => {
        var id = c.id;
        c.children = [];
        p[id] = c;
        return p;
      },
      { "#": { id: "#", children: [] } }
    );

    for (var key in tree) {
      var parent = tree[key].parent;
      if (!parent) continue;
      tree[parent].children.push(tree[key]);
    }

    return tree["#"];
  }
  drawTree(obj, depth, jsxArray) {
    if (obj.children.length == 0) return;
    obj.children.forEach((i) => {
      jsxArray.push(
        <div style={{ marginLeft: `${depth * 24}px` }}>
          <div className="tree-icon tree-leaf" />
          <div
            className={`tree-icon ${
              i.children.length == 0 ? "tree-file" : "tree-themeicon"
            }`}
          />
          {i.URL ? (
            i.ATTACH ? (
              <a
                href=""
                onClick={(evt) => {
                  this.props.showDialog({
                    isOpen: true,
                    title: "ESFS",
                    content: (
                      <div>
                        <p>
                          <a
                            href={DownloadFromWebAPI(i.URL)}
                            target="_blank"
                            onClick={i.onclick || function() {}}
                          >
                            Open PDF
                          </a>
                        </p>
                        <p>
                          <a
                            href={DownloadFromWebAPI(i.ATTACH)}
                            target="_blank"
                            onClick={i.onclick || function() {}}
                          >
                            Download Attachment
                          </a>
                        </p>
                      </div>
                    ),
                    onDialogOk: () => {},
                  });
                  evt.preventDefault();
                }}
              >
                {i.text}
              </a>
            ) : (
              <a
                href={DownloadFromWebAPI(i.URL)}
                target="_blank"
                onClick={i.onclick || function() {}}
              >
                {i.text}
              </a>
            )
          ) : (
            i.text
          )}
        </div>
      );
      this.drawTree(i, depth + 1, jsxArray);
    });
    return jsxArray;
  }
  render() {
    return (
      <div className="tree-container">
        {this.props.caption && <b>{this.props.caption}</b>}
        {this.drawTree(this.processTreeObj(this.props.tree), 0, [])}
      </div>
    );
  }
}

export default ClassName;
